import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('simpleFadeAnimation', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({
        opacity: 1,
        // transform: 'translateY(0)'
      })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(30px)'
        }),
        animate(500 )
      ])
    ])
  ]
})
export class HomePageComponent implements OnInit {
  public games$: Observable<any[]>;
  
  constructor() { }

  ngOnInit(): void {
    this.games$ = of([
      {
        title: 'Carmania'
      }
    ])
  }
}
